/* eslint-disable @typescript-eslint/ban-ts-comment */

export const gtagPushProperties = (event: string, properties: any = {}) => {
  // @ts-ignore
  if (typeof window !== undefined && 'dataLayer' in window && window.dataLayer && window.dataLayer.push) {
    try {
    // @ts-ignore
      window.dataLayer?.push({
        event,
        properties,
      });
    } catch(e) {
      console.error(e);
    }
  }
};

export const gtagPushEcomm = (event: string, ecommerce: any = {}) => {
  // @ts-ignore
  if (typeof window !== undefined && 'dataLayer' in window && window.dataLayer && window.dataLayer.push) {
    try {
    // @ts-ignore
      window.dataLayer?.push({
        event,
        ecommerce,
      });
    } catch(e) {
      console.error(e);
    }
  }
};